import { Segment } from "@hubble/web";
import { FILES } from "i18n/constants";
import { useTranslations } from "i18n";
import React from "react";
import type { CURRENCY_SEGMENT_TYPES } from "./utils";
import { getCurrencySegmentOptions } from "./utils";

interface CurrencySegmentSelectorProps {
  selectedValue: string;
  onChange: (value: string) => void;
  segmentTypes?: (keyof typeof CURRENCY_SEGMENT_TYPES)[];
}

const CurrencySegmentSelector: React.FC<CurrencySegmentSelectorProps> = ({
  selectedValue,
  onChange,
  segmentTypes
}) => {
  const t = useTranslations(FILES.CONVERTER);

  const handleSelectCurrencyType = (value: string) => {
    if (onChange) {
      onChange(value);
    }
  };
  const segments = getCurrencySegmentOptions(t);

  // If segmentTypes is defined, filter the array to only include the segments of those types
  const filteredSegments = segmentTypes
    ? segments.filter((segment) =>
        segmentTypes.includes(
          segment.type as keyof typeof CURRENCY_SEGMENT_TYPES
        )
      )
    : segments;

  return (
    <Segment
      size="sm"
      value={selectedValue}
      stretch
      variant="background"
      onChange={handleSelectCurrencyType}
      mb={1}
      mt={0}
    >
      {filteredSegments.map(({ type, localizedName }) => (
        <Segment.Button
          key={type}
          size="sm"
          data-testid={`${type}-btn`}
          value={type}
          cta={localizedName || type}
        />
      ))}
    </Segment>
  );
};

export default CurrencySegmentSelector;
